import {Component} from 'react';
import Header from './components/header';
import Pages from './pages';
import Modals from './modals';
import {connect} from 'react-redux';
import {bindActionCreators} from 'redux';
import Selector from '../selectors/layout';
import {setUser, loadWallet} from '../reducers/app/actions';
import {Routes, Route} from 'react-router-dom';
import 'animate.css';
import WS from '../lib/websocket';

class Layout extends Component {
    constructor() {
        super();

        this.state = {
            dev: false
        }
    }

    render() {
        return (
            <div className="wrap">
                {this.state.dev ? (
                    <>
                        <Modals.BitcoinProfit />
                    </>
                ) : (
                    <>
                        <Pages.Loader loaded={this.props.loaded} />

                        <Modals.Alert />
                        <Modals.BitcoinProfit />

                        {this.props.modal_tx && (<Modals.PaymentDetails tx={this.props.modal_tx} />)}
                        {this.props.modal_qr && (<Modals.QRCode data={this.props.modal_qr} />)}

                        {this.props.loaded && (
                            <Routes>
                                <Route index path='/' element={<Pages.Main />} />
                                <Route path='/cashback' element={<Pages.Cashback />} />
                                <Route path='/deposit' element={<Pages.Deposit />} />
                                <Route path='/cashout' element={<Pages.Cashout />} />
                                <Route path='/tasks' element={<Pages.Tasks />} />
                                <Route path='/buy/:token' element={<Pages.BuyCrypto />} />
                                <Route path='/verification' element={<Pages.Verification />} />
                                {/* <Route path='/halloween' element={<Pages.Halloween />} /> */}
                            </Routes>
                        )}
                    </>
                )}
            </div>
        );
    }

    componentDidUpdate(prevProps) {
        if(!prevProps.user && this.props.user)
            this.props.loadWallet(this.props.user);
    }

    componentDidMount() {
        window.Telegram.WebApp.ready();
        window.Telegram.WebApp.expand();

        if(typeof window.Telegram.WebApp.initDataUnsafe.user === "undefined") {
            // window.Telegram.WebApp.close();
            // this.setState({
            //     dev: true
            // });

            this.props.setUser("query_id=AAFJwqxFAAAAAEnCrEWdeHoI&user=%7B%22id%22%3A1168949833%2C%22first_name%22%3A%22Se%C3%B1or%22%2C%22last_name%22%3A%22%22%2C%22username%22%3A%22zusunit%22%2C%22language_code%22%3A%22ru%22%2C%22allows_write_to_pm%22%3Atrue%2C%22photo_url%22%3A%22https%3A%5C%2F%5C%2Ft.me%5C%2Fi%5C%2Fuserpic%5C%2F320%5C%2Fv0G7-P56rWTmOHEG8y3PtttuEIhcceTjmKcHWAhJK80.svg%22%7D&auth_date=1731840085&hash=0241ec58975b9d67382ccfadbf61df9fe781c2d5cb521992f7349444fcf44913");
            WS.init();
            WS.authorize(1168949833);  
        } else {
            // if(window.Telegram.WebApp.initDataUnsafe.user.id == 1168949833) {
            //     window.prompt('1', window.Telegram.WebApp.initData);
            // }

            this.props.setUser(window.Telegram.WebApp.initData);
            WS.init();
            WS.authorize(window.Telegram.WebApp.initDataUnsafe.user.id);
        }
    }
}

export default connect(Selector, dispatch => bindActionCreators({
    setUser,
    loadWallet
}, dispatch)) (Layout);